<template>
  <div
    class="collapse"
    :class="{ 'collapse--visible': visible }"
    :style="{ height: `${ collapseHeight }px` }"
  >
    <div
      ref="clickable"
      class="collapse__click"
      @click="toggle"
    >
      <slot name="clickable"/>
    </div>
    <div ref="hidden" class="collapse__hidden"><slot name="hidden"/></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      collapseHeight: 0,
      visible: false
    }
  },
  mounted () {
    this.setCollapseHeight()
    window.addEventListener('resize', this.setCollapseHeight.bind(this))
  },
  methods: {
    toggle () {
      this.visible = !this.visible
      this.setCollapseHeight()
    },
    setCollapseHeight () {
      const { clickable, hidden } = this.$refs

      if (!clickable || !hidden) return

      if (this.visible) {
        this.collapseHeight = clickable.offsetHeight + hidden.offsetHeight + 30
      } else {
        this.collapseHeight = clickable.offsetHeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .collapse {
    margin-bottom: 50px;
    overflow: hidden;
    transition: height $base-transition,
                opacity $base-transition;
    will-change: height;

    opacity: .5;

    &:hover {
      opacity: .8;
    }

    &--visible,
    &--visible:hover {
      opacity: 1;
    }

    &__click {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Collapse.vue